// import React from "react"
import LocaleWrap from "./wrapPageElement"

const { registerLinkResolver } = require("gatsby-source-prismic-graphql")
const { linkResolver } = require("./src/utils/linkResolver")

registerLinkResolver(linkResolver)

export const wrapPageElement = LocaleWrap
